import React, { useState, useEffect } from "react";

import { Grid, Typography, Avatar } from "@material-ui/core";
const noImg = require("./imgProfile.png");
export default (props) => {
    const [report, setReport] = useState(props.report);

    useEffect(() => {
        setReport(props.report);
    }, [props.report]);

    return (
        <React.Fragment style={{ paddingLeft: 24 }}>
            <Grid item xl={12} xs={12}>
                <Typography style={{ marginBottom: 30 }} variant="h5">
                    Attendee's
                </Typography>
                <Grid container spacing={8}>
                    {report.attendance &&
                        report.attendance.map((user, k) => {
                            return (
                                user && (
                                    <Grid
                                        key={k}
                                        sm={1}
                                        xs={1}
                                        md={4}
                                        lg={1}
                                        xl={1}
                                        style={{ textAlign: "center" }}
                                    >
                                        <Avatar
                                            src={props.userIcons[user.uid]}
                                            style={{
                                                height: "100",
                                                width: "100",
                                                margin: "0 auto",
                                            }}
                                            onError={(ev) => {
                                                ev.target.src = noImg;
                                            }}
                                        />
                                        <br />
                                        {user.user_name}
                                    </Grid>
                                )
                            );
                        })}
                </Grid>
            </Grid>
            <Grid item xl={12} xs={12}>
                <Typography style={{ marginBottom: 30 }} variant="h5">
                    Signatures
                </Typography>
                <Grid container spacing={8}>
                    {report.attached_signatures &&
                        report.attached_signatures.map(
                            (attachedSignature, j) => {
                                return (
                                    <Grid sm={2} xs={2} md={4} lg={2} xl={2}>
                                        <img
                                            alt="signature"
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                            }}
                                            src={
                                                attachedSignature.signature_url
                                            }
                                        />
                                        <br />
                                        <b> Name:</b>&nbsp;
                                        {attachedSignature.signature_name}
                                        <br />
                                        <b> Timestamp:</b>{" "}
                                        <p>
                                            {
                                                attachedSignature.signature_timestamp
                                            }
                                        </p>
                                    </Grid>
                                );
                            }
                        )}
                </Grid>
                <Grid item xl={12} xs={12}>
                <Typography style={{ marginBottom: 30, paddingTop: 20 }} variant="h5">
                   Thumbs Up Photos
                </Typography>
                <Grid container spacing={8}>
                    {report.attached_thumbsup_photos &&
                        report.attached_thumbsup_photos.map(
                            (attached_thumbsup_photo, j) => {
                                return (
                                    <Grid sm={2} xs={2} md={4} lg={2} xl={2}>
                                        <img
                                            alt="signature"
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                            }}
                                            src={
                                                attached_thumbsup_photo.photo_url
                                            }
                                        />
                                        <br />
                                        <b> Name:</b>&nbsp;
                                        {attached_thumbsup_photo.photo_name}
                                        <br />
                                        <b> Timestamp:</b>{" "}
                                        <p>
                                            {
                                                attached_thumbsup_photo.photo_timestamp
                                            }
                                        </p>
                                    </Grid>
                                );
                            }
                        )}
                </Grid>
            </Grid>
            </Grid>
        </React.Fragment>
    );
};
